import { GolfTournament, TournamentFeedCount } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

export type GolfTournamentWithFeedCount = GolfTournament & {
  count: {
    matchByExternalId?: TournamentFeedCount
    matchByInternalId?: TournamentFeedCount
  }
}

export const fetchTournamentsWithFeedCount = async (params?: {
  dateFrom?: string | undefined
  dateTo?: string | undefined
  signal?: AbortSignal
}) => {
  const [{ data: tournaments }, { data: tournamentsFeedCount }] = await Promise.all([
    ddeApi.endpoints.golf.tournaments.getTournaments(
      {
        dateFrom: params?.dateFrom,
        dateTo: params?.dateTo
      },
      params?.signal
    ),
    ddeApi.endpoints.golf.tournaments.getTournamentsFeedCount(params?.signal)
  ])

  const extendedTournaments = tournaments.reduce((acc: GolfTournamentWithFeedCount[], curr) => {
    const tournamentId = curr.externalId && curr.externalId.split('-')[1]

    const matchByInternalId = tournamentsFeedCount.tournaments.find(
      (webSocket) => webSocket.internalTournamentId === curr.id
    )
    const matchByExternalId = tournamentsFeedCount.tournaments.find(
      (tournament) => tournament.externalTournamentId === tournamentId
    )

    return [
      ...acc,
      {
        ...curr,
        count: {
          matchByExternalId,
          matchByInternalId
        }
      }
    ]
  }, [])

  return extendedTournaments
}
